import type { IContextMutationResult } from '@modules/core/services/query/types';
import type {
  ISettingsClickDomainAddPayload,
  ISettingsClickDomainsAddResponse,
  ISettingsClickDomainSetDefaultResponse,
} from '@modules/general-settings/submodules/click-domains/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS,
  SETTINGS_CLICK_DOMAINS_ADD_MUTATION_KEY,
  SETTINGS_CLICK_DOMAINS_ADD_URL,
  SETTINGS_CLICK_DOMAINS_LIST_QUERY_KEY,
} from '@modules/general-settings/submodules/click-domains/constants';
import { useToastStore } from '@modules/toast/store';

export default function useSettingsClickDomainsAddMutation(): IContextMutationResult<
  ISettingsClickDomainsAddResponse,
  Error,
  ISettingsClickDomainAddPayload
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    ISettingsClickDomainsAddResponse,
    Error,
    ISettingsClickDomainAddPayload
  >({
    mutationKey: [SETTINGS_CLICK_DOMAINS_ADD_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<ISettingsClickDomainSetDefaultResponse>(
      SETTINGS_CLICK_DOMAINS_ADD_URL,
      payload,
      {
        permission: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS.CLICKDOMAINS_EDIT,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_CLICK_DOMAINS_LIST_QUERY_KEY] });
      displayPresetToast('created');
    },
  });
}
